import { Injectable } from '@angular/core';
import { PortalConfigService } from '@tangilla/tg-ng-core';
import { TangillaFormsConfig } from '@tangilla/tg-ng-models';
import { Model } from 'survey-core';
import { ConfigColors } from '@tangilla/tg-ng-models/src/lib/models/src/utilities/portal-config';

@Injectable({
  providedIn: 'root'
})
export class FormProcessorService {
  constructor(private portalConfigService: PortalConfigService) {
  }

  processFormParameters(surveyModel: Model) {
    const generalFormParameters = (this.portalConfigService
      .portalConfig as TangillaFormsConfig)?.forms_variables.general;

    for (const formParameterKey in generalFormParameters) {
      surveyModel.setVariable(formParameterKey, (generalFormParameters as any)[formParameterKey]);
    }
  }
}
